/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown>, suffix: NonNullable<unknown> }} Audio_Recorder_Recording_Starts_InInputs */



/**
* | output |
* | --- |
* | "Recording starts in {seconds} second{suffix}" |
*
* @param {Audio_Recorder_Recording_Starts_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_starts_in = /** @type {((inputs: Audio_Recorder_Recording_Starts_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_Starts_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'enregistrement commence dans ${i?.seconds} seconde${i?.suffix}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Aufnahme beginnt in ${i?.seconds} Sekunde${i?.suffix}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`La registrazione inizia tra ${i?.seconds} secondi${i?.suffix}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Запись начинается через ${i?.seconds} секунду${i?.suffix}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`La grabación comienza en ${i?.seconds} segundo${i?.suffix}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`录制在${i?.seconds}秒${i?.suffix}开始`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`録音は${i?.seconds}秒後に開始されます${i?.suffix}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्डिंग ${i?.seconds} सेकंड${i?.suffix} में शुरू होती है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A gravação começa em ${i?.seconds} segundo${i?.suffix}`)
	return /** @type {LocalizedString} */ (`Recording starts in ${i?.seconds} second${i?.suffix}`)
});